import axios from 'axios';
import { store } from '../store';

const apiClient = axios.create({});

if (process.env.REACT_APP_API_URL) {
  apiClient.defaults.baseURL = process.env.REACT_APP_API_URL;
}

const setTokenHeader = config => {
  const editedConfig = config;
  const { user } = store.getState().auth;
  const token = user && user.token;
  if (token) {
    editedConfig.headers.Authorization = `Token ${token}`;
  }
  return editedConfig;
};

const catchRequestError = error => Promise.reject(error);

apiClient.interceptors.request.use(setTokenHeader, catchRequestError);

export default apiClient;



// WEBPACK FOOTER //
// ./src/utils/apiClient.js